// constants.ts
// Centralizované konstanty pro celou aplikaci

/**
 * Avatar choices
 */
export const AVATARS = {
  ROBERT: 'Robert',
  SILVIE: 'Silvie'
} as const

/**
 * Account types
 */
export const ACCOUNT_TYPES = {
  GOLD: 'Gold',
  RENTIER: 'Rentier',
  MAX: 'Max'
} as const

/**
 * Typy akcí ve video konfiguraci
 */
export const ACTION_TYPES = {
  XROAD: 'xroad',
  INTRO: 'intro',
  SELECT_AVATAR: 'selectAvatar',
  SELECTED_AVATAR: 'selectedAvatar',
  LINK: 'link',
  PANEL: 'panel',
  SWITCH_INTRO: 'switchIntro',
  PLAN_INTRO: 'planIntro',
  FEES: 'fees',
  EXAMPLES: 'examples',
  INGOLD_PAY: 'ingoldpay',
  SWITCH: 'switch',
  CONTACT_FORM: 'contactform',
  QA: 'qa',
  END: 'end',
} as const

/**
 * Typy stránek/overlays v aplikaci
 */
export const PAGE_TYPES = {
  LANGUAGE_SELECTOR: 'languageSelector',
  XROAD: 'xroad',
  VIDEO: 'video',
  ACCOUNTS: 'accounts',
  ACCOUNTS_INTRO: 'accountsIntro',
  CONTACT_FORM: 'contactForm',
  QA: 'qa',
} as const

/**
 * Tagy pro video navigaci (named anchors)
 */
export const NAVIGATION_TAGS = {
  INTRO_ACCOUNTS: 'introAccounts',
  OPEN_ACCOUNT: 'openAccount',
} as const

/**
 * Časové konstanty pro animace a UI
 */
export const TIMING_CONSTANTS = {
  FADE_DURATION: 300, // ms
  CONTROL_BAR_HEIGHT: 80, // px
} as const

/**
 * Konstanty pro video navigaci a indexy
 */
export const VIDEO_CONFIG = {
  /** Počet skip videí pro Max účet při 'fees' action */
  MAX_ACCOUNT_SKIP_COUNT: 2,
  /** Počet koncových videí (formulář, qa, poděkování, úvod) */
  END_VIDEOS_COUNT: 3,
} as const

/**
 * Panel variant types
 */
export const PANEL_VARIANTS = {
  PAMP: 'PanelPampContent',
  ROYAL_MINT: 'PanelRoyalMintContent',
  LLOYDS_INSURANCE: 'LoydsInsuranceContent',
} as const

/**
 * Xroad page navigation IDs
 */
export const XROAD_PAGES = {
  CONTINUE: 1,
  INTRO_ACCOUNTS: 2,
  OPEN_ACCOUNT: 3, // default
} as const
